import { useEffect, useState, useMemo } from "react";

const useStaticResources = (srcArray) => {
  const prefixMap = useMemo(() => ({
    '/img/logo': 'https://eodhistoricaldata.com',
    // Add more prefix mappings as required
  }), []); // Empty dependencies since this is static

  const [modifiedUrls, setModifiedUrls] = useState([]);

  useEffect(() => {
    if (srcArray && Array.isArray(srcArray)) {
      const urls = srcArray.map((url) => {
        for (const key in prefixMap) {
          if (url.startsWith(key)) {
            return `${prefixMap[key]}${url}`;
          }
        }
        return url;
      });
      setModifiedUrls(urls);
    }
  }, [srcArray, prefixMap]); // Now safe to include prefixMap

  return modifiedUrls;
};

export default useStaticResources;